<template>
  <div>
    <div class="wrap">
      <img class="image_1" referrerpolicy="no-referrer" src="./assets/img/1.jpg" />
      <div class="box_5" @click="goto1()">
        <div class="box_6">
          <img class="label_1" referrerpolicy="no-referrer" src="./assets/img/Android.png" />
          <span class="text_2">Android下载</span>
        </div>
      </div>
      <div class="box_5" style="bottom:18vh;" @click="goto2()">
        <div class="box_6">
          <img class="label_1" referrerpolicy="no-referrer" src="./assets/img/iPhone.png" />
          <span class="text_2">iPhone下载</span>
        </div>
      </div>

      <div class="box_8wrap">
        <img class="image_4" referrerpolicy="no-referrer"
          src="./assets/img/xiaochengxu.jpg" />
        <div class="box_8">
          <div class="box_9">
            <img class="thumbnail_1" referrerpolicy="no-referrer" src="./assets/img/slices.png" />
            <span class="text_3">壹护聘书小程序</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods:{
    goto1(){
      window.location.href='https://a.app.qq.com/o/simple.jsp?pkgname=chinanurse.cn.nurse'
    },
    goto2(){
      window.location.href='https://a.app.qq.com/o/simple.jsp?pkgname=chinanurse.cn.nurse'
    },
  }
}
</script>

<style lang="less" scoped>
.wrap {
  position: relative;
  height: 100vh;

  .image_1 {
    width: 100%;
    height: 100vh;
  }

  .box_8wrap {
    width: 136px;
    height: 158px;
    position: absolute;
    left: 5%;
    bottom: 8vh;

    .image_4 {
      width: 130px;
      height: 113px;
      display: block;
      margin: 0 auto;
      vertical-align: middle;
    }

    .box_8 {
      height: 40px;
      border-radius: 8px;
      background-color: rgba(71, 132, 254, 1);
      margin: 0 auto;
      width: 136px;

      .box_9 {
        width: 136px;
        height: 40px;

        .thumbnail_1 {
          width: 15px;
          height: 15px;
          vertical-align: middle;
          margin: 0 auto;
          margin-left: 5px;
        }

        .text_3 {
          width: 111px;
          display: inline-block;
          color: rgba(255, 255, 255, 1);
          font-size: 14px;
          letter-spacing: 1.2000000476837158px;
          font-family: SourceHanSansCN-Bold;
          white-space: nowrap;
          height: 40px;
          line-height: 40px;
          text-align: right;
        }
      }
    }
  }

  .box_5 {
    position: absolute;
    right: 5%;
    bottom: 8vh;
    height: 52px;
    border-radius: 45px;
    border: 8px solid rgba(72, 134, 250, 1);
    background-color: rgba(255, 255, 255, 1);
    width: 167px;

    .box_6 {
      width: 100%;
      height: 35px;
      margin: 0 auto;
      margin-left: 16px;

      .label_1 {
        width: 20px;
        height: auto;
        vertical-align: middle;
      }

      .text_2 {
        width: 100px;
        height: 30px;
        text-align: center;
        display: inline-block;
        color: rgba(37, 112, 255, 1);
        font-size: 14px;
        white-space: nowrap;
        line-height: 30px;
        text-align: center;
        margin-top: 3px;
      }
    }
  }
}
</style>